module.exports = __webpack_public_path__ + "img/electrify.6e3cea49.png";